import { render, staticRenderFns } from "./HomebuyerGuide.vue?vue&type=template&id=671f6276&scoped=true&"
import script from "./HomebuyerGuide.vue?vue&type=script&lang=js&"
export * from "./HomebuyerGuide.vue?vue&type=script&lang=js&"
import style0 from "./HomebuyerGuide.vue?vue&type=style&index=0&id=671f6276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f6276",
  null
  
)

export default component.exports